<template>
  <div>
    <el-dialog
      :title="$t('Información de Usuario')"
      :visible.sync="visibleSync"
      :before-close="onCancel"
    >
      <el-form
        :model="user"
        v-loading="findUser"
        element-loading-text="Buscando usuario..."
        element-loading-background="rgba(255, 255, 255)"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Rut">
              <el-input :disabled="action === 'update'" v-model="user.rut" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Correo')">
              <el-input v-model="user.email" :disabled="findUser === true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Nombre')">
              <el-input v-model="user.nombre" :disabled="findUser === true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('Apellido')">
              <el-input v-model="user.apellido" :disabled="findUser === true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col v-if="user && user.roles" :span="24">
            <span class="dialog-title">Roles Faena</span>
            <br />
            <br />
          </el-col>
          <!-- Administrador -->
          <el-col v-if="user && user.roles" :span="24">
            <el-checkbox v-model="user.roles.admin">{{ $t('Administrador de Faena') }}</el-checkbox>
          </el-col>
          <el-col v-if="user && user.roles && !user.roles.admin" :span="24">
            <!-- Roles Areas -->
            <el-col :span="24">
              <br />
              <br />
              <el-tabs v-model="activeName">
                <!-- TAB ROLES AREAS -->
                <el-tab-pane :label="$t('Roles en Áreas')" name="area-roles">
                  <el-table
                    :key="forceUpdate"
                    v-if="user.roles.areas"
                    :data="Object.entries(user.roles.areas)"
                    stripe
                    style="width: 100%"
                  >
                    <el-table-column label="Área">
                      <template
                        slot-scope="scope"
                      >{{ getAreaName(scope.row[0]) === "GeneralAreasRoles" ? "Todas las áreas" : getAreaName(scope.row[0]) }}</template>
                    </el-table-column>
                    <el-table-column label="Roles" width="250">
                      <template slot-scope="scope">
                        <ul>
                          <li
                            v-for="(role) in scope.row[1]"
                            :key="role"
                          >{{ bhpRoles[role].role || role }}</li>
                        </ul>
                      </template>
                    </el-table-column>
                    <el-table-column label width="50">
                      <template slot-scope="scope">
                        <center>
                          <i
                            class="el-icon-edit"
                            style="cursor: pointer;"
                            @click="option = 'update', setAuxRole('bhp', scope.row[0], scope.row[1])"
                          />
                        </center>
                      </template>
                    </el-table-column>
                    <el-table-column label width="50">
                      <template slot-scope="scope">
                        <center>
                          <i
                            class="el-icon-close"
                            style="cursor: pointer;"
                            @click="deleteRoleArea(scope.row)"
                          />
                        </center>
                      </template>
                    </el-table-column>
                  </el-table>
                  <br />
                  <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-plus"
                    class="right mt-10"
                    @click="option = 'add', setAuxRole('bhp')"
                  >{{$t('Añadir Área')}}</el-button>
                </el-tab-pane>
                <!-- TAB ROLES EMPRESAS -->
                <el-tab-pane :label="$t('Roles en Empresas')" name="company-roles">
                  <el-table
                    v-if="user.roles.empresas"
                    :data="Object.entries(user.roles.empresas)"
                    border
                    style="width: 100%"
                  >
                    <el-table-column label="Empresa">
                      <template slot-scope="scope">{{ getEmpresaName(scope.row[0]) }}</template>
                    </el-table-column>
                    <el-table-column label="Roles">
                      <template slot-scope="scope">
                        <ul>
                          <li
                            v-for="(role) in scope.row[1]"
                            :key="role"
                          >{{ contractorSubContractorRoles[role].role || role }}</li>
                        </ul>
                      </template>
                    </el-table-column>
                    <el-table-column label width="100">
                      <template slot-scope="scope">
                        <center>
                          <i
                            class="el-icon-edit"
                            @click="option = 'update', setAuxRole('contractor', scope.row[0], scope.row[1])"
                          />
                        </center>
                      </template>
                    </el-table-column>
                    <el-table-column label width="50">
                      <template slot-scope="scope">
                        <center>
                          <i
                            class="el-icon-close"
                            style="cursor: pointer;"
                            @click="deleteRoleEmpresas(scope.row)"
                          />
                        </center>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-plus"
                    class="right mt-10"
                    @click="option = 'add', setAuxRole('contractor')"
                  >{{ $t('Añadir Empresa') }}</el-button>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="aceptar">{{ $t('Guardar Cambios') }}</el-button>
        <el-button @click="onCancel">{{ $t('Cerrar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="50%"
      :title="$t('Asignación de Roles')"
      :visible.sync="innerDialogRoles"
      append-to-body
    >
      <h3>{{ auxAC.title }}</h3>
      <el-select v-model="auxUserACRoles.key" filterable class="w-100">
        <el-option v-for="ac in auxAC.acs" :key="ac._id" :label="ac.nombre" :value="ac._id" />
      </el-select>
      <br />
      <br />
      <el-row type="flex" justify="center">
        <el-col :span="21">
          <center>
            <el-checkbox-group v-model="auxUserACRoles.roles" class="checkbox-roles">
              <el-checkbox
                class="checkRoles"
                v-for="(role, r) in auxAC.roles"
                :key="r"
                :label="r"
              >{{ role.role }}</el-checkbox>
            </el-checkbox-group>
          </center>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="auxUserACRoles.key === ''"
          @click="addAuxRolesToUser()"
        >{{ $t('Confirmar Roles') }}</el-button>
        <el-button @click="cleanAux(); innerDialogRoles = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      option: "",
      key: "",
      type: "",
      forceUpdate: 0,
      activeName: "area-roles",
      innerDialogRoles: false,
      auxAC: {
        title: "",
        acs: [],
        roles: {}
      },
      auxUserACRoles: {
        type: "bhp",
        key: "",
        roles: []
      },
      bhpRoles: {
        health: { role: "Especialista Salud", disabled: false },
        safety: { role: "Especialista Seguridad", disabled: false },
        environment: { role: "Especialista Medioambiente", disabled: false },
        owner: { role: "Dueño de contrato", disabled: false },
        risk: { role: "Especialista de Riesgos", disabled: false },
        coordinator: { role: "Coordinador", disabled: false },
        super: { role: "Superintendente", disabled: true },
        manager: { role: "Gerente", disabled: true },
        hse: { role: "HSE", disabled: true }
      },
      contractorSubContractorRoles: {
        contractor_hse: { role: "HSE (Contratista)", disabled: false },
        administrator: {
          role: "Administrador de contrato (Contratista)",
          disabled: false
        },
        contractor_coordinator: {
          role: "Coordinador (Contratista)",
          disabled: false
        }
        /* sub_contractor_hse: { role: 'HSE (Sub-Contratista)', disabled: false },
        sub_admin: { role: 'Administrador de contrato (Sub-Contratista)', disabled: false },
        sub_contractor_coordinator: { role: 'Coordinador (Sub-Contratista)', disabled: false }, */
      }
    };
  },
  props: ["user", "visibleSync", "onAcept", "onCancel", "action", "findUser"],
  methods: {
    deleteRoleArea(role) {
      this.$confirm(
        "Estás a punto de eliminar un Rol. ¿Deseas Continuar?",
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
        .then(() => {
          delete this.user.roles.areas[role[0]];
          this.forceUpdate = this.forceUpdate + 1;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Acción cancelada"
          });
        });
    },
    deleteRoleEmpresas(role) {
      this.$confirm(
        "Estás a punto de eliminar un Rol. ¿Deseas Continuar?",
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
        .then(() => {
          delete this.user.roles.empresas[role[0]];
          this.forceUpdate = this.forceUpdate + 1;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Acción cancelada"
          });
        });
    },
    aceptar() {
      this.onAcept(this.action);
    },
    cleanAux() {
      this.auxAC = {
        title: "",
        acs: [],
        roles: {}
      };
      this.auxUserACRoles = {
        type: "bhp",
        key: "",
        roles: []
      };
    },
    addAuxRolesToUser() {
      const ac = this.auxUserACRoles.type === "bhp" ? "areas" : "empresas";
      if (!this.user.roles[ac]) {
        this.user.roles[ac] = {};
      }
      this.user.roles[ac][this.auxUserACRoles.key] = this.auxUserACRoles.roles;
      if (
        this.llave !== this.auxUserACRoles.key &&
        ac === "empresas" &&
        this.action === "update"
      ) {
        delete this.user.roles.empresas[this.llave];
      }
      if (
        this.llave !== this.auxUserACRoles.key &&
        ac === "areas" &&
        this.action === "update"
      ) {
        delete this.user.roles.areas[this.llave];
      }
      this.innerDialogRoles = false;
      // this.cleanAux();
    },
    setAuxRole(type, key = "", roles = []) {
      this.llave = key;
      if (type === "bhp") {
        this.auxAC.title = "Área";
        this.auxAC.acs = [
          { _id: "GeneralAreasRoles", nombre: "TODAS LAS ÁREAS" }
        ];
        this.auxAC.acs = JSON.parse(
          JSON.stringify(this.auxAC.acs.concat(this.$store.getters.areas))
        );
        this.auxAC.roles = this.bhpRoles;
        if (this.option === "add") {
          if (this.user.roles.area !== undefined) {
            let keys = Object.keys(this.user.roles.areas);
            for (let i = 0; i < keys.length; i++) {
              let pos = this.auxAC.acs
                .map(function(e) {
                  return e._id;
                })
                .indexOf(keys[i]);
              if (pos !== -1) {
                this.auxAC.acs.splice(pos, 1);
              }
            }
          }
        }
        if (this.option === "update") {
          if (this.user.roles.area !== undefined) {
            let keys = Object.keys(this.user.roles.areas);
            let pos = keys.indexOf(this.llave);
            if (pos !== -1) {
              keys.splice(pos, 1);
            }
            for (let i = 0; i < keys.length; i++) {
              let pos = this.auxAC.acs
                .map(function(e) {
                  return e._id;
                })
                .indexOf(keys[i]);
              if (pos !== -1) {
                this.auxAC.acs.splice(pos, 1);
              }
            }
          }
        }
      } else {
        this.auxAC.title = "Empresa";
        this.auxAC.acs = JSON.parse(
          JSON.stringify(this.$store.getters.empresas)
        );
        this.auxAC.roles = this.contractorSubContractorRoles;
        if (this.option === "add") {
          if (this.user.roles.empresas !== undefined) {
            let keys = Object.keys(this.user.roles.empresas);
            for (let i = 0; i < keys.length; i++) {
              let pos = this.auxAC.acs
                .map(function(e) {
                  return e._id;
                })
                .indexOf(keys[i]);
              if (pos !== -1) {
                this.auxAC.acs.splice(pos, 1);
              }
            }
          }
        }
        if (this.option === "update") {
          if (this.user.roles.empresas !== undefined) {
            let keys = Object.keys(this.user.roles.empresas);
            let pos = keys.indexOf(this.llave);
            if (pos !== -1) {
              keys.splice(pos, 1);
            }
            for (let i = 0; i < keys.length; i++) {
              let pos = this.auxAC.acs
                .map(function(e) {
                  return e._id;
                })
                .indexOf(keys[i]);
              if (pos !== -1) {
                this.auxAC.acs.splice(pos, 1);
              }
            }
          }
        }
      }
      this.auxUserACRoles = { type, key, roles };
      this.innerDialogRoles = true;
    },
    getAreaName(areaId) {
      const area = this.$store.getters.areas.find(a => a._id === areaId);
      if (area) {
        return area.nombre;
      }
      return areaId;
    },
    getEmpresaName(id) {
      let empresa = this.$store.getters.empresas.find(c => c._id === id);
      if (empresa) {
        return empresa.nombre;
      } else {
        return id;
      }
    }
  }
};
</script>

<style scoped>
.checkRoles {
  margin-top: 20px;
}
</style>
